module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/header-watch-list-6afd2a323ad0641708968a75fad0078a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/header-watch-list.svg
// module id = VjxV
// module chunks = 24